import { TextPanel } from "..";
import { useMetaVariableStore } from "../../../../store";
import styles from "../AdvancedPanel.module.css";
import { useAdvancedPanelTimeline } from "../useAdvancedPanelTimeline";
import { TimelineButton } from "./TimeLineButton";
import { useObjectsState } from "../../../../../../contexts/ObjectsProvider";
import { useTimeline } from "../../../../../../contexts/TimelineProvider/TimelineProvider";
import { Collapse } from "./Collapse";
import useCollapseState from "../../../../../../hooks/useCollapseState";
import { FloatingTextEditor } from "../../FloatingTextEditor";

interface TextProps {
  data: TextPanel;
  onChange: () => void;
  onFocus: () => void;
  active: boolean;
}

export function Text({ data, onChange, onFocus, active }: Readonly<TextProps>) {
  const value = useMetaVariableStore((s) => s.metaVariables[data.key]);
  const metaData = useMetaVariableStore((s) => s.metaVariablesData[data.key]);
  const setMetadata = useMetaVariableStore((s) => s.setMetaData);
  const set = useMetaVariableStore((s) => s.setMetaVariable);
  const upsertAnimatedMetaVariable = useMetaVariableStore((s) => s.upsertAnimatedMetaVariable);
  const [tl] = useTimeline();
  const currentTime = tl?.scrubbingCurrentTime;
  const selectedObjectId = useObjectsState().selectedObjects[0]?.objectId;
  const { isObjectInTimeline, handleTimelineClick, metaVariableInCurrentTime } = useAdvancedPanelTimeline(data.key);
  const { isOpen, handleCollapseToggle, elementRef } = useCollapseState(data.key);

  const handleToggle = (newState: boolean) => {
    handleCollapseToggle(newState);
  };

  const onTimelineClick = () => {
    handleTimelineClick(value);
    onChange();
  };

  const handleHideClick = () => {
    setMetadata(data.key, "hide", !metaData?.hide);
    onChange();
  };

  const handleChange = (newText: string) => {
    set(data.key, newText);
    if (isObjectInTimeline) {
      upsertAnimatedMetaVariable(data.key, currentTime, newText, selectedObjectId);
    }
    onChange();
  };

  const setSelectedFont = (font: string) => {
    setMetadata(data.key, "selectedFont", font);
  };

  return (
    <Collapse title={data.name} id={data.key} isOpen={isOpen} onToggle={handleToggle}>
      <div ref={elementRef} id={`panel-${data.key}`} className={styles.group} key={data.name}>
        <div className={styles.timelineWrapper}>
          <div className={styles.selectWrapper}>
            <div className={styles.textGroup}>
              <FloatingTextEditor
                value={value as string}
                onChange={handleChange}
                id={data.key}
                onFocus={onFocus}
                active={active}
                font={metaData?.font ?? "sans-serif"}
                setSelectedFont={setSelectedFont}
              />
            </div>
            <div className={styles.checkboxWrapper}>
              <input type="checkbox" checked={!metaData?.hide} onChange={handleHideClick} />
              <p>Hide</p>
            </div>
          </div>
          {isObjectInTimeline && <TimelineButton onClick={onTimelineClick} active={!!metaVariableInCurrentTime} />}
        </div>
      </div>
    </Collapse>
  );
}
